import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getSaveState, subscribeSaveState } from '../../saveStatus';
import { timeAgo } from '../../toast';
import { t } from '../../i18n';

// Indicateur d'enregistrement : rien tant qu'aucune modification n'a été faite pendant la session.
class SaveIndicator extends Component {

  state = { save: getSaveState(), tick: 0 };

  componentDidMount() {
    this.unsubscribe = subscribeSaveState((save) => this.setState({ save }));
    this.timer = setInterval(() => this.setState(({ tick }) => ({ tick: tick + 1 })), 30000);
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    clearInterval(this.timer);
  }

  render() {
    const { status, savedAt } = this.state.save;
    if (status === 'idle' && !savedAt) return null;
    const label = {
      saving: t('ui.save.saving'),
      error: t('ui.save.error'),
      saved: t('ui.save.saved', { when: timeAgo(savedAt) }),
      idle: t('ui.save.saved', { when: timeAgo(savedAt) }),
    }[status];
    return (
      <span className={`tsk-save-indicator tsk-save-indicator--${status}`} role='status'>
        <FontAwesomeIcon icon={['fas', status === 'saving' ? 'sync-alt' : status === 'error' ? 'exclamation-triangle' : 'check-circle']} spin={status === 'saving'} />
        {label}
      </span>
    );
  }
}

export default SaveIndicator;
